<template>
  <div>
    <!--    搜索部分-->
    <el-form :inline="true" :model="enquiryForm" class="demo-form-inline" label-width="80px">
      <el-form-item label="盟友">
        <el-input placeholder="请选择" v-model="enquiryForm.user" size="medium" :disabled="true">
          <el-button slot="append" @click="mechanismSearch(3)">选择</el-button>
        </el-input>
      </el-form-item>

      <el-form-item label="考核月份">
        <el-date-picker
            v-model="enquiryForm.assess_month"
            type="month"
            value-format="yyyy-MM"
            placeholder="选择月" 
            :picker-options="pickerOptions"
            > 
        </el-date-picker>
      </el-form-item>
      <el-form-item label="发放状态">
        <el-select v-model="enquiryForm.reward_status" medium clearable placeholder="请选择发放状态">
          <el-option label="未发放" value="0"></el-option>
          <el-option label="已发放" value="1"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div style="margin-bottom: 10px">
      <el-button size="medium" type="primary" style="font-size: 12px;" @click="handleSearch(enquiryForm)">查询
      </el-button>
      <el-button size="medium" style="font-size: 12px;" @click="Reset(enquiryForm)">重置</el-button>
      <el-button size="medium" type="warning" style="font-size: 12px;" @click="exportData">导出</el-button>
      <el-button size="medium" type="danger" style="font-size: 12px;" @click="printEvent()"> 打印</el-button>
      <span style="color: #000;font-weight: bold;margin-left: 10px">
          <span style="color:red"> {{tbCount.assess_month}} </span> ：
          总交易额 <span style="color:red"> {{tbCount.total_trade_amount}} </span>元，
          总分红人数：<span style="color:red"> {{tbCount.total_dividend_num}} </span> 人，
      </span>
    </div>
    <!-- //打印 -->
    <prints ref="prints" :tableData="tableData" :tableTh="tableTh" :tableTd="tableTd" v-show="false"></prints>
    <!--    表格部分-->
    <el-table :data="tableData" style="width: 100%" :default-sort="{prop: 'date', order: 'descending'}"
              v-loading="loading" border id="tableDataId" size="mini">            
      <el-table-column header-align="center" align="center" prop="assess_month" label="考核月份" sortable>
      </el-table-column>
      <el-table-column header-align="center" align="center" prop="user_name" label="达标人">
      </el-table-column>
      <el-table-column header-align="center" align="center" prop="user_role" label="达标人身份">
      </el-table-column>
      <el-table-column header-align="center" align="center" prop="is_vip" label="是否是常驻会员">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.is_vip == '0'" type="danger" disable-transitions>
            否
        </el-tag>
        <el-tag v-if="scope.row.is_vip == '1'" type="success" disable-transitions>
            是
        </el-tag>
        </template>
      </el-table-column>
      <el-table-column header-align="center" align="center" prop="total_team_trade_amount" label="月交易额">
      </el-table-column>  
      <el-table-column header-align="center" align="center" prop="total_pos_num" label="总台数">
      </el-table-column>
      <el-table-column header-align="center" align="center" prop="total_pos_bind_num" label="总绑定台数">
      </el-table-column>
      <el-table-column header-align="center" align="center" prop="total_pos_active_num" label="总激活台数">
      </el-table-column>
      <el-table-column header-align="center" align="center" prop="average_trade_amount" label="台均交易金额">
      </el-table-column>
      <el-table-column header-align="center" align="center" prop="reward_amount" label="发放金额">
      </el-table-column>
      <el-table-column header-align="center" align="center" prop="reward_status" label="发放状态">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.reward_status.value == '0'" type="danger" disable-transitions>
            {{ scope.row.reward_status.text }}
          </el-tag>
          <el-tag v-if="scope.row.reward_status.value == '1'" type="success" disable-transitions>
            {{ scope.row.reward_status.text }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column header-align="center" align="center" prop="reward_user" label="发放人">
      </el-table-column>
      <el-table-column header-align="center" align="center" prop="reward_time" label="发放时间">
      </el-table-column>
      <el-table-column fixed="right" header-align="center" align="center" label="操作" min-width="100">
        <template slot-scope="scope" style="text-align: center;">
          <el-button type="text" v-if="scope.row.reward_status.value == '0'"   @click="info(scope.row)">发放</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页部分 -->
    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                   :page-sizes="[20,50,100,200,500,1000]" :page-size="page_size" :total="total"
                   layout="total, sizes, prev, pager, next, jumper" style="text-align: right"></el-pagination>

    <!--      机构选择表单部分-->
    <el-dialog v-if="dialogVisible" title="配置表单" :visible.sync="dialogVisible">
      <!--    搜索部分-->
      <el-form :inline="true" :model="dialogForm" class="demo-form-inline">
        <el-form-item label="名称">
          <el-input size="medium" clearable v-model="dialogForm.user_name" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input size="medium" clearable v-model="dialogForm.mobile_phone" placeholder="请输入"></el-input>
        </el-form-item>
        <el-button size="medium" type="primary" style="font-size: 12px;" @click="handleSearch1(dialogForm)">搜索
        </el-button>
        <el-button size="medium" style="font-size: 12px;" @click="handleSearch2(dialogForm)">重置</el-button>
      </el-form>
      <!--    表格部分-->
      <el-table height="250" :data="dialogData" style="width: 100%"
                :default-sort="{prop: 'date', order: 'descending'}" v-loading="loading1" border
                @row-click="singleElection">
        <el-table-column align="center" width="55">
          <template slot="header">
            <span style="cursor:pointer" @click="cancelClick">取消</span>
          </template>
          <template slot-scope="scope">
            <el-radio class="radio" v-model="templateSelection" :label="scope.row.id">
              {{ " " }}
            </el-radio>
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" prop="id" label="ID" sortable>
        </el-table-column>
        <el-table-column header-align="center" align="center" prop="user_name" label="代理商名称">
        </el-table-column>
        <el-table-column header-align="center" align="center" prop="mobile_phone" label="代理商手机号">
        </el-table-column>
      </el-table>
      <!-- 分页部分 -->
      <el-pagination background @size-change="handleSizeChange1" @current-change="handleCurrentChange1"
                     :page-sizes="[20,50,100,200,500,1000]" :page-size="page_size1" :total="dialogTotal"
                     layout="total, sizes, prev, pager, next, jumper" style="text-align: right"></el-pagination>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelDialog">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  export_json_to_excel
} from "@/excel/Export2Excel";
import prints from '@/components/print.vue'
import {getMonth} from  '@/utils/validate'
export default {
  name: "userInformationOne",
  components: {
    prints
  },
  data() {
    return {
      // 主页面部分
      loading: true, //列表loadding
      page_size: 20, //条数
      total: 0, //总数
      tableData: [], //表格数据
      enquiryForm: {
        page_size: 20,
        page: 1,
        user: '',
        user_id: '',
        assess_month:'',
        reward_status:'',
        reward_level:'',
      },

      // 表单部分
      loading1: true, //列表loadding
      page_size1: 20, //表单条数
      dialogTotal: 0, //表单总数
      dialogData: [], //表单数据 盟友
      dialogVisible: false, //表单页面显示
      dialogForm: { //表单搜索数据
        page_size: 20,
        mobile_phone: "", //手机号码
        page: 1,
        user_name: "", //用户名称
      },
      //   当前选择的行的id
      templateSelection: "",
      //   当前选择的行的数据
      checkList: [],
      tableTdList: [],
      tableThList: [],
      choiceState: 0,
      //打印
      tableTh: null,
      tableTd: null,
      //统计数据 
      tbCount:{
        assess_month: "",
        total_trade_amount: 0,
        total_bronze_num: 0,
        total_silver_num: 0,
        total_gold_num: 0,
      },
      //时间戳配置 
      pickerOptions: {
          disabledDate(time) {
            //获取当前时间 
            let timer =  new Date();
            let day = timer.getDate();
            //小于十号读取上个月的 
            let date;
            if(day < 10){
              //计算上上个月  
               date = getMonth(timer.getFullYear(),timer.getMonth(),2);
            }else{
               //计算上个月 
               date = getMonth(timer.getFullYear(),timer.getMonth(),1);
            }
            return time.getTime() > date;
          }
      }    
    }
  },
  created() {
    this.getData(this.enquiryForm)
    this.tableTh = ['考核月份', '达标人', '达标人身份','常驻会员','月交易额', '总台数','总绑定数', '总激活台数',  '台均交易金额', '发放金额', '发放状态', '发放人', '发放时间'];
    this.tableTd = ['assess_month', 'user_name', 'user_role','is_vip','total_team_trade_amount', 'total_pos_num','total_pos_bind_num', 'total_pos_active_num','average_trade_amount','reward_amount', 'reward_status', 'reward_user', 'reward_time'];
    this.$nextTick(() => {
      this.$refs.prints.prints();
    })
  },
  methods: {
    //打印
    printEvent() {
      this.tableData.forEach(item => { //实名状态转换文本
        item.current_target_status_text = item.current_target_status.text;
        item.reward_status_text = item.reward_status.text;
      });
      this.$nextTick(() => {
        this.$refs.prints.prints();
        this.$refs.prints.print();
      })
    },
    //发放奖励 
    info(row) {
      let data = {
        id: row.id,
      }
      this.$confirm('即将发放该用户私董会分红奖励, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$api.post("/api/dividend/sendReward", data, res => {
          if (res.status == 200) {
            this.$message.success(res.msg);
            this.getData(this.enquiryForm)
          } else {
            this.$message.error(res.msg);
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    // 主页面部分
    //搜索
    handleSearch(searchForm) {
      searchForm.page = 1;
      this.getData(searchForm);
    },
    //重置
    Reset(searchForm) {
      searchForm.page = 1;
      searchForm.user = '';
      searchForm.user_id = '';
      searchForm.assess_month = "";
      searchForm.reward_status = "";
      searchForm.reward_level = "";
      this.getData(searchForm);
    },
    //分页
    handleCurrentChange(page) { //当前选中页
      this.enquiryForm.page = page;
      this.getData(this.enquiryForm);
    },
    handleSizeChange(limit) { //条数
      this.enquiryForm.page_size = limit;
      this.enquiryForm.page = 1;
      this.getData(this.enquiryForm);
    },
    //获取数据
    getData(params) { //初始化数据
      this.loading = true;
      this.$api.post("/api/dividend/getList?page=" + params.page, params, res => {
        if (res.status == 200) {
          let tableData = res.data;
          this.total = tableData.total; //总数
          this.tableData = tableData.list;
          this.tbCount = tableData.statistics_data; //统计 
        } else {
          this.$message.error(res.msg);
        }
        //渲染结束后取消加载
        this.loading = false;
      })
    },

    // 导出
    exportData() {
      let th = ['考核月份', '达标人', '达标人身份','常驻会员', '月交易额', '总台数','总绑定数', '总激活台数',  '台均交易金额', '发放金额', '发放状态', '发放人', '发放时间'];
      let excelData  = ['assess_month', 'user_name', 'user_role','is_vip','total_team_trade_amount', 'total_pos_num','total_pos_bind_num', 'total_pos_active_num','average_trade_amount','reward_amount', 'reward_status', 'reward_user', 'reward_time'];
      this.tableData.forEach(item => { //实名状态转换文本
        item.reward_status_text = item.reward_status.text;
      });
      let data = this.formatJson(excelData, this.tableData);
      let defaultTitle = '导出文件';
      export_json_to_excel(th, data, defaultTitle)
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    // 表单部分
    //表单分页
    handleCurrentChange1(page) { //当前选中页
      this.dialogForm.page = page;
      this.getDialogData(this.dialogForm, this.choiceState);
    },
    handleSizeChange1(limit) { //表单条数
      this.dialogForm.page_size = limit;
      this.dialogForm.page = 1;
      this.getDialogData(this.dialogForm, this.choiceState);
    },
    //表单搜索
    handleSearch1(dialogForm) {
      dialogForm.page = 1;
      this.getDialogData(dialogForm, this.choiceState);
    },
    //表单重置
    handleSearch2(dialogForm) {
      dialogForm.page = 1;
      dialogForm.mobile_phone = '';
      dialogForm.user_name = '';
      this.getDialogData(dialogForm, this.choiceState);
    },
    // 机构选择页面显示（表单显示）
    mechanismSearch(can) {
      this.dialogVisible = true;
      this.getDialogData(this.dialogForm, can);
    },
    //表单获取数据
    getDialogData(params, can) { //初始化数据
      this.choiceState = can;
      let url = '';
      if (can == 3) {
        url = "/api/agent/getUserAgent?page=" + params.page
      }
      this.loading1 = true;
      this.$api.post(url, params, res => {
        if (res.status == 200) {
          let dialogData = res.data;
          this.dialogTotal = dialogData.total; //总数
          this.dialogData = dialogData.list;
        } else {
          this.$message.error(res.msg);
        }
        //渲染结束后取消加载
        this.loading1 = false;
      })
    },
    //获取每行
    singleElection(row) {
      this.templateSelection = row.id;
      this.checkList = row;
      // this.checkList = this.dialogData.filter((item) => item.id === row.id)
    },
    //取消
    cancelClick() {
      this.checkList = [];
      this.templateSelection = '';
    },
    // 表单确定
    submitForm() {
      if (this.choiceState == 3) {
        this.enquiryForm.user = this.checkList.user_name;
        this.enquiryForm.user_id = this.checkList.id;
      }
      this.handleSearch2(this.dialogForm);
      this.cancelClick();
      this.dialogVisible = false;
      this.getData(this.enquiryForm);
    },
    //表单取消
    cancelDialog() {
      this.handleSearch2(this.dialogForm);
      this.cancelClick();
      this.dialogVisible = false;

    }
  }
}
</script>

<style scoped>
/deep/ .el-form-item__content .el-input-group {
  vertical-align: middle !important;
}

.code {
  cursor: pointer;
}

.code:hover {
  color: blue;
  text-decoration: underline;
}

.transactionInfoBox {
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}

.transactionInfoBoxTitle {
  font-style: normal;
  display: inline-block;
  width: 150px;
  text-align: right;
  font-weight: 700;
}
</style>
